import { LitElement, html, css } from 'lit';
import { msg } from '@lit/localize';
import { hideRevealInputs, validateForm,validationHandler,validationHandlerClear } from '../../utilities/formsUtilities';
import { accessibility,formStyles } from '../../utilities/styles';
import { setFileValueFromDataUrl } from '../../utilities/formsUtilities';
import { EventManager } from '../../utilities/events';

export class AllInPagedFormSubpage extends LitElement {
    static properties = {
        title: { type: String },
        formName: { type: String },
        show: { type: Boolean, reflect: true },
        reveal: { type: Boolean, state: true },
    }

    constructor() {
        super();
        this._internals = this.attachInternals();
    }
    
    get fields(){
        let children = this._slottedChildren;
        if(!children) return [];
        let _fields = children.map(el=>{
            if(el.tagName=='INPUT'||el.tagName=='TEXTAREA'||el.tagName=='SELECT'||el.tagName=='ALLIN-IMAGE-UPLOADER'){
                return el;
            }
            return el.querySelectorAll('input,textarea,select,allin-image-uploader');
        }).filter(el=>el);
        let fields = [];
        _fields.forEach(el=>{
            if(el.length){
                el.forEach(i=>{
                    fields.push(i);
                })
            }
            else{
                fields.push(el);
            }
        });
        return fields;
    }

    get _slottedChildren() {
        let slot;
        if(this.showHeader){
            slot = this.renderRoot.querySelectorAll('slot')[1];
        }
        else{
            slot = this.renderRoot.querySelector('slot');
        }
        return slot?.assignedElements({flatten: true});
    }

    get _slot() {
        return this.shadowRoot.querySelector('slot');
    }

    get _alerts(){
        let children = this._slottedChildren;
        if(!children) return [];
        let _alerts = children.filter(el=>el.classList.contains('alert'));
        return _alerts;
    }

    connectedCallback(){
        super.connectedCallback();
    }

    updated(changedProperties){
        if(changedProperties.has('show') && !this.show){
            let children = this._slottedChildren;
            if(!children) return;
            children.forEach(child=>{
                let radios = child.querySelectorAll('input[type="radio"]');
                if(radios.length){
                    radios.forEach(radio=>{
                        if(radio.value === 'not_needed'){
                            radio.checked = true;
                        }
                    });
                }
            })
        } 
    }
    setShowState(show){
        this.show = show;
    }

    setRevealState(reveal){
        this.reveal = reveal;
    }

    getShowValue(){
        return this.show;
    }

    isCurrent(){
        return this.show && this.reveal;
    }

    isCompleted(){
        const inputs = this.querySelectorAll(':checked');
        const filteredInputs = Array.from(inputs).filter(input => input.value !== 'not_needed');
        return filteredInputs.length > 0;
    }

    render() {
        return html` 
            <div class="subpage-wrapper ${this.reveal ? 'reveal' : 'hide'}" >
                <div class="message notice" aria-live="polite"></div>
                <div class="subpage">
                    <h2>${this.title}</h2>
                    <slot></slot>
                </div>
            </div>
        `
    }

    static styles = [
        accessibility,
        
        css`
        :host:has(>.hide){
            display:none;
        }
        .subpage-wrapper{
            transition: opacity 0.3s ease-in-out;
        }
        .subpage-wrapper.hide{
            opacity: 0;
            display:none;
            pointer-events: none;
            padding: 0!important;
        }
        .subpage-wrapper.reveal{
            opacity: 1;
            pointer-events: auto;
        }`
    ]
}


